import {QueryClient} from '@tanstack/react-query'

/**
 * The one QueryClient, shared with the chat socket's event router, which writes pushed events
 * straight into this cache (server state lives here, never in Zustand).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: 1000,
    },
  },
})
